<template>
    <div class="bottom-nav">
      <router-link
        v-for="item in menuItems"
        :key="item.path"
        :to="item.path"
        class="nav-item"
        :class="{ active: isActive(item.path) }"
        @click="handleMore(item)"
      >
        <i :class="item.icon"></i>
        <span>{{ item.name }}</span>
      </router-link>
    </div>
  
    <!-- 更多菜单抽屉（从底部弹出） -->
    <div v-if="showMoreMenu" class="more-drawer" @click.self="showMoreMenu = false">
      <div class="drawer-content">
        <div class="drawer-header">
          <span>更多功能</span>
          <button @click="showMoreMenu = false">关闭</button>
        </div>
        <div class="drawer-items">
          <router-link
            v-for="item in extraMenu"
            :key="item.path"
            :to="item.path"
            class="drawer-item"
            @click="showMoreMenu = false"
          >
            <i :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        showMoreMenu: false,
        menuItems: [
          { name: "主页", path: "/admin", icon: "fas fa-home" },
          { name: "表单", path: "/form", icon: "fas fa-file-alt" },
          { name: "二维码", path: "/qrcode", icon: "fas fa-qrcode" },
          { name: "还款", path: "/repayment-periods", icon: "fas fa-calendar-check" },
          { name: "更多", path: "#", icon: "fas fa-ellipsis-h" }   // path 用 #，点击触发菜单
        ],
        extraMenu: [
          { name: "行业/职位", path: "/industry-position", icon: "fas fa-briefcase" },
          { name: "贷款用途", path: "/loan-purpose", icon: "fas fa-hand-holding-usd" },
          { name: "人物关系", path: "/personal-relationships", icon: "fas fa-users" },
          { name: "参数配置", path: "/parameter-configurations", icon: "fas fa-cog" },
        ]
      };
    },
    methods: {
      isActive(path) {
        return this.$route.path === path || this.$route.path.startsWith(path);
      },
      handleMore(item) {
        if (item.name === "更多") {
          this.showMoreMenu = true;   // 从底部弹出菜单
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .bottom-nav {
    position: fixed;
    bottom: 0; left: 0; right: 0;
    height: 50px;
    background: rgba(15, 23, 42, 0.96);
    backdrop-filter: blur(20px);
    border-top: 1px solid rgba(148, 163, 184, 0.25);
    display: flex;
    align-items: center;
    justify-content: space-around;
    z-index: 1000;
    box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.25);
    padding-bottom: env(safe-area-inset-bottom);
  }
  
  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #94a3b8;
    text-decoration: none;
    font-size: 10.5px;
    flex: 1;
    height: 100%;
    justify-content: center;
  }
  
  .nav-item i { font-size: 18px; margin-bottom: 4px; }
  .nav-item.active { color: #60a5fa; font-weight: 600; }
  .nav-item.active i { transform: scale(1.15); }
  
  /* 从底部弹出的更多菜单 */
  .more-drawer {
    position: fixed;
    bottom: 0; left: 0; right: 0; top: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1100;
    display: flex;
    align-items: flex-end;
  }
  
  .drawer-content {
    background: rgba(15, 23, 42, 0.98);
    backdrop-filter: blur(20px);
    width: 100%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 20px 0 30px;
    max-height: 65vh;
    overflow-y: auto;
  }
  
  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px 16px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.2);
    color: #f1f5f9;
    font-size: 17px;
    font-weight: 600;
  }
  
  .drawer-header button {
    background: none; border: none; color: #60a5fa; font-size: 15px;
  }
  
  .drawer-items {
    padding: 12px 0;
  }
  
  .drawer-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 24px;
    color: #e2e8f0;
    text-decoration: none;
    font-size: 16px;
  }
  
  .drawer-item:hover {
    background: rgba(148, 163, 184, 0.15);
  }
  
  .drawer-item i { font-size: 22px; width: 28px; }
  </style>